
import React from 'react';
import ZNetwork from "./znetwork";
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZUtil from "./zutil";
import AMC from "./AMC";
import AMCForm from "./AMCForm";
import AMCConstants from "./AMCConstants";
import {APP} from "./App";
import {KINDS} from "./AMCConstants";
import ZooErrorFoundPage from "./ZooErrorFoundPage";
import ZooNothingFoundPage from "./ZooNothingFoundPage";
import ZAPI from "./zapi";
import { Rock } from "./rs";
import ZooNoResultsFound from "./ZooNoResultsFound";
import { ZooSearchResultLineItem } from "./ZooLeaderboardsPage";
import PleaseStandBy from "./PleaseStandBy";
import AMCTransactionsManagerFactory from './AMCTransactions';
import { ZooSearchBar, ZooEmbeddedSearchResults, ZooProfilePageContents, ZooDatasourceViewer, RockAreYouSure, ZooDebugConsole } from "./ZooProfilePage";
import AMCCloneButton from './AMCCloneButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStream, faChevronRight, faFolder, faFolderOpen, faUsers, faHome, faCog, faSearch, faChevronDown, faEdit, faCode, faEye, faTimes, faTerminal, faPencilAlt, faCheckCircle, faBan } from '@fortawesome/free-solid-svg-icons'
import { ROCK_NOTEBOOK_HEADER_STYLES } from './AMCConstants';

export default class RockPanel extends React.Component {
	constructor(props) {
		super(props);
		this.state = { panel: this.props.selected_panel || "notebook" };
	}
	componentDidMount() {
		let { target_uri } = this.props;
		let cookies = JSON.parse(ZUtil.getCandy("rockstarpanel") || "{}");
		if (cookies && cookies.target_uri === target_uri) {
			this.setState({ panel: cookies.panel });
		}
		if (this.props.selected_panel) {
			this.setState({ panel: this.props.selected_panel });
		}
		let target = ZProps.get(target_uri);
		if (!target) {
			AMC.getBundle(target_uri, (err, bundle) => {
				this.setState({ target: ZProps.get(target_uri) });
			});
		} else {
			this.setState({ target: target });
		}
	}
/*
	areYouSure(msg, yes_function) {
		this.setState({ push_panel: this.state.selected_panel, selected_panel: "areyousure", areyousure: yes_function, areyousuremsg: msg });
	}
	theyAreSure(flag, event) {
		if (flag) {
			this.state.areyousure(event);
		}
		this.setState({ panel: this.state.push_panel, areyousure: null, areyousuremsg: null});
	}
*/
	// used?
	_updateCandies(state) {
		ZUtil.setCandy("rockstarpanel", JSON.stringify(state));
	}
	togglePanel = (which, force) => {
		let { onSelectPanel } = this.props;
		let panel = (force !== true && this.state.panel === which) ? null : which;
		this.setState({ panel: panel });
		this._updateCandies({ panel: panel, target_uri: this.state.target.uri });
		if (onSelectPanel) {
			onSelectPanel(panel, true);
		}
	}
	onOperation() { }
	saveType(item_uri, callback) {
		AMC.save(item_uri, (err) => {
			if (!err) {
				this.setState({ saved: Date.now() });
			}
			if (callback) {
				callback(err);
			}
		});
	}
	render() {
		let { service, transman, areyousuremsg, onClosePanel, assignPropsToRock, assignTypeToRock, is_mini, is_workspace, onRockSelect } = this.props;
		let { target, panel } = this.state;

		ZLog.debug("ROCKPANEL RENDERING:" + panel);

		let item = service;
		let panelwidget = null;
		let panel_manages_scrolling = null;
		let typetransman = null;

		if (!target) {
			panelwidget = <PleaseStandBy /> 
		} else {
			if (panel === "type" && AMC.isEditable(target)) {
				typetransman = AMCTransactionsManagerFactory.manage(target);
				typetransman.setSaver(uri => { ZUtil.throttle(uri, () => this.saveType(uri), 1000) });
			}
			switch (panel) {
				case "source" :
					panelwidget = <RockInspectorSourceCode key={target.uri} item={target} />;
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "raw" :
					panelwidget = <RockRawProperties key={target.uri + "raw"} item={target} service={service} transman={transman} typetransman={typetransman} togglePanel={this.togglePanel} />;
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "properties" :
					panelwidget = <RockInspectorPropertiesForm editable={AMC.isEditable(item || target)} key={target.uri} node={target} transman={transman} typetransman={typetransman} is_type={false} />
					break;
				case "type" :
					panelwidget = <RockInspectorPropertiesForm editable={AMC.isEditable(item || target)} key={target.uri + "type"} node={target} transman={transman} typetransman={typetransman} is_type={true} />
					break;
				case "profile" :
ZLog.log("profile of item and usually its type: ", { target: target});
					let type = target.kind === "service" ? target : ZProps.get(target.type);
					panelwidget = type ? <ZooProfilePageContents key={type.uri} item={type} /> : <h1>Type {target.type} not found</h1>
					break;
//				case "helpmechoose" :
//					panelwidget = <RockstarFab key={target.uri} service={item} focus={target} graph={this.graphman} transman={transman} readonly={!AMC.isEditable(target)} />
//					break;
				case "implementations" :
					panelwidget = <RockPanelSearch key={target.uri + "types"} item={target} kind={target.kind} placeholder={"Search " + target.kind + " implementations..."} assignComponentToRock={assignTypeToRock} type_not_instances={true} />
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "search zoo" :
					panelwidget = <RockPanelSearch key={target.uri} item={target} kind={target.kind} placeholder={"Search " + target.kind + " zoo..."} assignComponentToRock={assignPropsToRock} />
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "usedby" :
					panelwidget = <ZooEmbeddedSearchResults key={target.uri} item={target} kind="usedby" />
					break;
				case "preview" :
					panelwidget = <ZooDatasourceViewer key={target.uri} item={target} />
					break;
				case "areyousure" :
					panelwidget = <RockAreYouSure theyAreSure={this.theyAreSure.bind(this)} msg={areyousuremsg} />
					break;
				case "notebook" :
					panelwidget = <RockNotebook key={item.uri} service={item} focus={target.uri} onSelect={onRockSelect} />
					panel_manages_scrolling = { overflow: "hidden" };
					break;
//				case "dashboard" :
//					panelwidget = <RockDashboard key={item.uri} service={item} runtime={runtime} focus={"train"} onOperation={this.onOperation.bind(this)} />
//					panel_manages_scrolling = { overflow: "hidden" };
//					break;
				case "logs" :
					panelwidget = <ZooDebugConsole key={item.uri} service={item} focus={"train"} />
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				case "editor" :
					panelwidget = 
						<div style={{height: "100%", position: "relative"}}>
						<div className="RockstarEditorPanelScroller">
							<Rock node={item} ed={{}} service={item} errors_by_uri={{}} />
						</div>
						<div className="RockstarEditorPanelReadOnlyBarrier"></div>
						</div>
					panel_manages_scrolling = { overflow: "hidden" };
					break;
				default : 
					break;
			}
		}
//					<RockPanelCrumbs item={target} />
		return (
			<div className="RockPanelArea" onClick={e => ZUtil.absorbEvent(e)}>
				<RockPanelControls panel={panel} item={service} part={target}  togglePanel={this.togglePanel} is_mini={is_mini} is_workspace={is_workspace} />
				{ onClosePanel ?
				<div className="RockPanelAreaHeader">
					<div className="RockPanelCloseButton" onClick={onClosePanel}><FontAwesomeIcon icon={faTimes} /></div>
				</div>
				: '' }
				<div className="RockPanelAreaContent" style={panel_manages_scrolling} >
					<ErrorBoundary>
					{ panelwidget }
					</ErrorBoundary>
				</div>
			</div>
		);
	}
}
class RockPanelControls extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		let { panel, item, part, togglePanel, is_mini, is_workspace } = this.props;
		let target = part || item || {};
		let is_app = target.kind === "service";
		
		ZLog.debug("RockPanelControls is_mini=" + is_mini);
		let buttondefs = 
			is_mini ? 
				[
					{ panel: "source", label: "", icon: faCode },
					{ panel: "type", label: "", icon: faEdit, text: "properties" },
					{ panel: "usedby", label: "", icon: faUsers, text: "users" }, 
					{ panel: "implementations", label: "", icon: faSearch, text: "search" },
					{ panel: "raw", label: "", icon: faCog },
				]
			: is_app ? 
			[ 
				{ panel: "notebook", label: "", icon: faStream, text: "elements" },
				{ panel: "logs", label: "", icon: faTerminal, text: "console" },
				{ panel: "source", label: "", icon: faCode },
				{ panel: "properties", label: "", icon: faPencilAlt },
				{ panel: "profile", label: "", icon: faHome },
			]
			:
			[ 
				{ panel: "notebook", label: "", icon: faStream, text: "elements" },
				{ panel: "logs", label: "", icon: faTerminal, text: "console" },
				{ panel: "source", label: "", icon: faCode },
				{ panel: "properties", label: "", icon: faPencilAlt },
				{ panel: "profile", label: "", icon: faHome },
				{ panel: "type", label: "", icon: faEdit },
				{ panel: "usedby", label: "", icon: faUsers, text: "users" }, 
				{ panel: "implementations", label: "", icon: faSearch, text: "search" },
				{ panel: "raw", label: "", icon: faCog },
			] 
		if (is_app && is_workspace) {
			buttondefs.unshift({ panel: "editor", label: "", icon: faStream, text: "graph" });
		}
		if (target.kind === "datasource" || target.kind === "modelsource") {
			// ? why? buttondefs.push({ panel: "search zoo", label: "", icon: faSearch });
		}
		if (target.kind === "dataset") {
			buttondefs.push({ panel: "contents", label: "", icon: faEye, text: "data" });
		}
		let buttons = buttondefs.map( b => {
			return <div key={b.panel} className={"RockPanelControl" + (panel === b.panel ? " RockPanelControlSelected" : "")}><span onClick={e => togglePanel(b.panel)}>{b.text || b.panel}</span> </div> 
		} );
		return ( 
			
				<div className="RockPanelControls">
					<div className="RockPanelControlsContent">
						{buttons}
					</div>
				</div>
		)
	}
}
class RockPanelSearch extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { kind } = this.props;
		ZNetwork.get("search", "is:" + kind, (err, list) => {
			this.setState({ items: (list && list[kind + "s"]) || [] });
		});
	}
	onSearch = (keyword) => {
		let { kind } = this.props;
		ZNetwork.get("search", (kind ? "is:" + kind + " " : "") + keyword, (err, list) => {
			this.setState({ items: (list && list[kind + "s"]) || [] });
		});
	}
	onClick = (item) => {
		this.setState({ selected_item: item });
		this.props.assignComponentToRock(this.props.item, item);
	}
	toggleWTF = () => {
		let { kind } = this.props;
		let wtf = this.state.wtf;
		if (!wtf) {
			let content = ZProps.get("wtf");
			if (!content) {
				return ZNetwork.get("wtf", null, null, (err, content) => {
					if (!err) {
						ZProps.set("wtf", content);
						this.toggleWTF();
					}
				});
			}
			content = content.dictionary;
			content = AMC.buildHTMLFromMarkup(content[kind] || "");
			this.setState({ wtf: content });
		} else {
			this.setState({ wtf: false });
		}
	}
	toggleHelpMeChoose(force) {
		let { kind } = this.props;
		let helpmechoose = this.state.helpmechoose;
		if (!helpmechoose && force !== false) {
			let content = ZProps.get("helpmechoose");
			if (!content) {
				return ZNetwork.get("thing", "core/helpmechoose/basics", (err, content) => {
					if (!err) {
						ZProps.set("helpmechoose", content);
						this.toggleHelpMeChoose();
					}
				});
			}
			content = AMC.buildHTMLFromMarkup(content.dictionary[kind] || "");
			this.setState({ helpmechoose: content });
		} else {
			this.setState({ helpmechoose: false });
		}
	}
	render() {
		let { placeholder, kind, item, type_not_instances } = this.props;
		let { items, helpmechoose, wtf, selected_item } = this.state;
		if (!items) {
			return <PleaseStandBy />;
		}
		if (items.length === 0) {
			return <div className="ZooEmbeddedSearchResults"><ZooNoResultsFound /></div>
		}
		if (this.state.error) {
			return <ZooErrorFoundPage />;
		}

		let default_item = item ? (type_not_instances ? (item.type ? ZProps.get(item.type) : item) : item) : null;
		selected_item = selected_item || default_item || {};
		if (default_item && !items.find( item => item.uri === default_item.uri )) {
			items.unshift(default_item);
		}
		let items_widgets = [];
		for (let i = 0; i < items.length; ++i) {
			let selected = items[i].uri === selected_item.uri;
			// key needs to change when selected
			let button = <input type="radio" key={items[i].uri + selected} name="implementation" checked={selected} onChange={e => this.onClick(items[i])} />
			items_widgets.push(<ZooSearchResultLineItem key={i} item={items[i]} rank={button} onClick={this.onClick} />);
		}
		let wtf_button = <span className={"WTFButton" + (wtf ? " WTFButtonSelected" : "")} title="What's this For?" onClick={this.toggleWTF}>WTF</span>
		let header =
			<div className="RockPanelSearchHeader ClearFix">
				<h4>{ kind } {wtf_button}</h4>
				<div className="RockPanelSearchHeaderBar">
					<span className={"FactoryHelpMeChooseButton" + (helpmechoose ? " FabHelpMeChooseButtonSelected" : "")} onClick={this.toggleHelpMeChoose.bind(this)}>Help me choose</span>
				</div>
			</div>
		return (
			<div>
				<div className="ZooEmbeddedSearchResults">
					{header}
					{ wtf ? <div className="WTFContent"><FontAwesomeIcon icon={KINDS.wtf.icon} /> {wtf} </div> : '' }
					{ helpmechoose ? <div className="HelpMeChooseContent">{helpmechoose} </div> : '' }
					{items_widgets}
				</div>
				<ZooSearchBar onSearch={this.onSearch} placeholder={placeholder} />
			</div>
		)
	}
}
export class RockInspectorPropertiesForm  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { node, is_type } = this.props;
		if (!is_type && node.kind !== "service") {
			AMC.getSpec(node, (err, spec) => {
				this.spec_name_to_spec = {};
				spec = (spec && spec.fields) || [];
				spec.forEach( x => { this.spec_name_to_spec[x.field] = x } );
				this.setState({ spec: spec, selected_node: node });
			});
		} else {
			let spec = AMCConstants.COMMON_SPEC.slice();
			if (AMCConstants.COMMON_SPECS[node.kind]) {
				spec = spec.concat(AMCConstants.COMMON_SPECS[node.kind]);
			}
			if (!AMC.isPremiumUser()) {
				spec.permissions.disabled = true;
			}
			this.spec_name_to_spec = {};
			spec.forEach( x => { this.spec_name_to_spec[x.field] = x } );
			this.setState({ spec: spec, selected_node: node });
		}
	}
	editURI = () => {
		APP.areYouSure( () => {
			APP.showPopup(<RockInspectorPropertiesFormEditURI node={this.state.selected_node} />); return { popup: true };
		}, "Are you sure about that? Any links elsewhere that point to this will no longer work" );
	}
	onChange(properties) {
		let { editable, transman, typetransman, is_type } = this.props;
		let node = this.state.selected_node;
		// expect just one prop at a time...
		// let name = Object.keys(properties)[0];
		ZLog.debug("onChange properties: ", { properties: properties, node: node.uri });
		if (!is_type && node.kind !== "service") {
			// modify instance inside of service...
			if (transman) {
				if (editable) {
					let props = {};
					Object.keys(properties).forEach( name => {
						let value = properties[name];
						if (value === "") {
							value = undefined;
						}
//ZLog.debug("spec_name_to_spec=", { name: name, value: value, nodevalue: node[name], spec_name_to_spec: this.spec_name_to_spec });
						if (node[name] !== value && this.spec_name_to_spec[name]["default"] !== value) {
							props[name] = value;
						}
					});
					if (Object.keys(props).length > 0) {
ZLog.debug("onChange props: ", { props: props });
						ZUtil.throttle("RockInspectorPropertiesForm" + node.uri, () => {
							let id = transman.startTransaction("user edited " + node.name);
							transman.modifyPart(node.uri, props);
							transman.endTransaction(id);
						}, 1000);
					}
				}
			return;
			}
		}
		transman = typetransman || AMCTransactionsManagerFactory.manage(node);
		let { protected_props, free_props } = this.formPropertiesToNodeProperties(node, properties);
//ZLog.special("onChange ", { protected_props: protected_props, free_props: free_props, properties: properties });
		let id = transman.startTransaction("user edited " + node.name);
		if (AMC.isEditable(node)) {
			transman.update(protected_props);
		}
		transman.update(free_props);
		transman.endTransaction(id);
		if (!typetransman) {
			AMCTransactionsManagerFactory.unmanage(transman);
		}
	}
	formPropertiesToNodeProperties(node, properties) {
		let readonly_props = {};
		let protected_props = {};
		let free_props = {};
		//let editable = AMC.isEditable(service); 
		Object.keys(properties).forEach( name => { 
			if (!this.spec_name_to_spec[name]) {
				ZLog.error("No spec for property", { property: name, specs: this.spec_name_to_spec });
				ZLog.debug("this.spec_name_to_spec=" + ZUtil.inspect(this.spec_name_to_spec));
			} else if (this.spec_name_to_spec[name]["protected"]) {
				protected_props[name] = properties[name];
			} else if (this.spec_name_to_spec[name].readonly) {
				readonly_props[name] = properties[name];
			} else {
				free_props[name] = properties[name];
			}
		});
		return { readonly_props: readonly_props, protected_props: protected_props, free_props: free_props };
	}
	nodePropertiesToFormProperties(node) {
		let { editable, is_type } = this.props;
		let readonly_props = {};
		let values = {};
		//let type = node.kind === "service" ? node : ZProps.get(node.type);
		let type = node.type ? ZProps.get(node.type) : node;
		editable = is_type ? AMC.isOwner(type) : editable;
		// let editable = !this.props.readonly; // WModel.isEditable(this.props.app);
		let owner = editable;
		for (let i = 0; i < this.state.spec.length; ++i) {
			let spec = this.state.spec[i];
			let name = spec.field;
			if (spec["protected"]) { // owneronly aka protected
				if (!owner) {
					readonly_props[name] = true;
				}
			} else if (spec.readonly) {
				readonly_props[name] = true;
			} else {
				if (!editable) {
					readonly_props[name] = true;
				}
			}
			values[name] = type[name] || spec.defaultvalue;
		}
		return { readonly_props: readonly_props, values: values };
	}
	render() {
		let { editable, node, tableless, is_type } = this.props;
		let { spec } = this.state;
		if (!spec) {
			return <PleaseStandBy />;
		}
		let is_service = node.kind === "service";
		if (node.kind !== "service" && node.type && !ZProps.get(node.type)) {
			ZLog.error("RockNodePropertiesForm - Type not found", { node: node });
			return <div className="CENTERED">Type not found</div>
		}
		let readonly = editable;
		let { readonly_props } = this.nodePropertiesToFormProperties(node);
		let type = (node.type && ZProps.get(node.type)) || node
//ZLog.log("RockNodePropertiesForm values", {values: values, readonly_props: readonly_props});
		spec = spec.slice();
		let is_owner = AMC.isEditable(type);
		let user = ZProps.get("user");
		if (is_owner && (user.plan === "guest" || user.plan === "member")) {
			readonly_props.permsssions = true;
		}
		if (is_type) {
//ZLog.debug("is type: is_owner=" + is_owner, { type: type });
			spec.unshift( { name: "Editable", field: "editable", kind: "annotation", annotation: <div className="RockNodePropertiesFormInclude"><span className="RockNodePropertiesFormOwner">{is_owner ? <span className="RockNodePropertiesFormOwnerYes"><FontAwesomeIcon icon={faCheckCircle} /> owner</span> : <span className="RockNodePropertiesFormOwnerNo"><FontAwesomeIcon icon={faBan} /> not owner</span>}</span> <AMCCloneButton item={type} link="/zoo/" /> </div>, hint: "Clone this component and make one for yourself if you are not owner but wish to edit it" } );
		}
		if (!is_type && !is_service) {
			spec.unshift({ name: "Name", field: "name", kind: "string", minlen: 1, maxlen: 64, hint: "Convenient name for this component", required: false, "protected": true });
		}
		if (!is_type && !is_service) { //  && node.kind !== "service") {
			spec.unshift( { name: "Type", field: "type", kind: "annotation", annotation: <div className="RockNodePropertiesFormInclude"><h2 className="RockNodePropertiesFormType">{node.type || node.uri}</h2></div>, hint: "The particular 'class' that implements the functionality of this component" } );
		}
		if (is_service) {
			spec.splice(1, 0, { name: "URI", field: "uri", kind: "annotation", annotation: <div className="RockNodePropertiesFormInclude"><h2 className="RockNodePropertiesFormType RockInspectorPropertiesFormURIField">{node.uri} { is_service && editable ? <button onClick={this.editURI}>Edit</button> : '' }</h2></div>, hint: "The address of this service" } );
		}
//ZLog.debug("spec fields:", { spec: spec});
//ZLog.debug("type :", { type: type});
//ZLog.debug("readonly_props :", { readonly_props: readonly_props});
		return (
			<div className="RockNodePropertiesForm ZooGeneralPage">
				<AMCForm tableless={tableless} fields={spec} values={is_type ? type : node} readonly_props={readonly_props} readonly={readonly} onChange={this.onChange.bind(this)} />
			</div>
		);
	}
}
class RockInspectorPropertiesFormEditURI  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	isValid = (str) => {
		let MINSIZE = 6;
		let MAXSIZE = 64;
		let error = null;
		if (str.search(/[^a-zA-Z0-9\-_]+$/) !== -1) {
			error = "Only A-z, 0-9, -, and _ allowed";
		}
		if (str.length < MINSIZE) {
			error = "Too short!";
		}
		if (str.length > MAXSIZE) {
			error = "Too long!";
		}
		this.setState({ error });
		if (error) {
			return false;
		}
		return true;
	}
	onChange = (e) => {
		ZUtil.absorbEvent(e);
		let { node } = this.props;
		let str = e.target.value;
		let valid = this.isValid(str);
		if (e.key === "Enter" && valid) {
			AMC.updateURI(node.uri, str, err => {
				if (err) {
					APP.setError("Unable to change address of service: " + err);
				} else {
					window.location.href = "/zoo/" + ZProps.get("user").group + "/" + node.kind + "/" + str;
				}
			});
		}
	}
	render() {
		let { node } = this.props;
		let { error } = this.state;
//			<div className="RockInspectorPropertiesFormEditURI CENTEREDPART POPUP" onClick={e => e.stopPropagation()}>
		return (
			<div className="RockInspectorPropertiesFormEditURI CENTEREDPART">
				<p>Edit URI which is used as the unique part of URL address</p>
				<input type="text" className={error ? "RockInspectorPropertiesFormEditURIError" : ''} autoFocus onChange={this.onChange} onKeyUp={this.onChange} defaultValue={node.uri.split("/")[2]} />
				<div className="RockInspectorPropertiesFormEditURIErrorMsg">{ error }</div>
			</div>
		);
	}
}
class RockNotebook  extends React.Component {
	constructor(props) {
		super(props);
		let cookies = JSON.parse(ZUtil.getCandy("RockNotebook") || "{}");
		if (!cookies.opened) {
			let { service } = props;
			cookies.opened = {};
			let nodes = AMC.getFlattenedService(service);
			nodes.forEach( n => cookies.opened[n.uri] = true );
		}
		this.state = { opened: cookies.opened };
	}
	componentDidMount() {
		this.componentDidUpdate();
	}
	toggleOpen = (uri) => {
		let opened = this.state.opened;
		// Make sure these cookies stay reasonably sized
/*
		// local storage...
		if (JSON.stringify(opened).length > 1000) {
			Object.keys(opened).forEach( key => {
				if (key !== uri) {
					ZLog.debug("Deleting notebook cookies for service to reduce cookies size: " + key);
					delete opened[key];
				}
			});
		}
*/
		opened[uri] = !opened[uri];
		let pipelines_opened = {};
		Object.keys(opened).filter( uri => uri.indexOf("pipeline") ).forEach( uri => pipelines_opened[uri] = true );
		this.setState({ opened: opened });
		ZUtil.setCandy("RockNotebook", JSON.stringify({ opened: opened }))
	}
	onFocus = (uri) => {
		this.props.onSelect(uri, true);
// nope		ZUtil.scrollToTop("nb_" + uri, "rocknotebook_scroller");
	}
	onScroll = () => {
		this.user_manually_moved_scroller = true;
	}
	render() {
		let { service, focus } = this.props;
		ZLog.debug("RockNotebook focus=" + focus);

		let model = service.nodes.find( n => n.kind === "modelsource" );
		let pipelines = (model.nodes || []).map( p => <RockNotebookPipeline key={p.uri} service={service} pipeline={p} opened={this.state.opened} nb={this} focus={focus} /> );
		pipelines = pipelines.concat(service.nodes.filter( n => n.kind === "pipeline" ).map( p => <RockNotebookPipeline key={p.uri} pipeline={p} opened={this.state.opened} nb={this} focus={focus} /> ));
		let app = <RockNotebookApp nodes={service.nodes.filter( n => n.kind === "ui" )} opened={this.state.opened} nb={this} focus={focus} />
			
		return (
			<div className="RockNotebook">
				<div className="RockNotebookScroller" id="rocknotebook_scroller" onScroll={this.onScroll}>
					{ pipelines }
					{ app }
				</div>
			</div>
		);
	}
	componentDidUpdate() {
		let { focus } = this.props;
		if (focus != null && focus.split("/")[1] !== "service") { // && !this.user_manually_moved_scroller) {
			setTimeout(() => {
				ZUtil.scrollToTop("nb_" + focus, "rocknotebook_scroller", true);
			}, 10);
		}
	}
}
class RockNotebookPipeline  extends React.Component {
	constructor(props) {
		super(props);
		let { focus, pipeline } = props;
		ZLog.debug("RockNotebookPipeline - purpose=" + pipeline.purpose + ".focus=" + focus + ",focused=" + pipeline.nodes.find( n => n.uri === focus ));
		this.state = { focused: focus && pipeline.nodes.find( n => n.uri === focus) };
	}
	componentDidMount() {
		this.componentDidUpdate();
	}
	toggleWTF = (e) => {
		e.stopPropagation();
		e.preventDefault();
		let { pipeline } = this.props;
		let key = pipeline.purpose + (pipeline.purpose === "production" ? "" : "ing") + " pipeline";
		this.setState({ wtf: this.state.wtf ? null : <div><strong>{key}</strong>{AMC.buildHTMLFromMarkup(AMC.getSetting("wtf").dictionary[key] || "What's This For? TBD")}</div> });
	}
	render() {
		let { service, pipeline, opened, nb, focus } = this.props;
		let { wtf, focused } = this.state;

		let open = opened[pipeline.uri];
		let wtf_button = <span className={"WTFButton" + (wtf ? " WTFButtonSelected" : "")} title="What's this For?" onClick={e => this.toggleWTF(e)}>WTF</span>

		let pipe = <div className="RockNotebookPipelineHeader" onClick={e => nb.toggleOpen(pipeline.uri)}>
				<FontAwesomeIcon icon={open ? faFolderOpen : faFolder} />
				<div className="RockNotebookPipelineBar" style={ROCK_NOTEBOOK_HEADER_STYLES[pipeline.purpose]}>
					{ pipeline.purpose + (pipeline.purpose === "production" ? "" : "ing") + " pipeline" }
					{ wtf_button }
				</div>
		</div>
		let contents = [];
		if (open || focused) {
			contents = pipeline.nodes.map( n => {
				let type = ZProps.get(n.type);
				if (!type) {
					ZLog.warn("Node type not found: " + n.type);
					return [<h1>{"Node type not found: " + n.type}</h1>];
				}
				let lines = [];
				lines.push( <RockNotebookFunction key={n.uri + "f"} node={n} type={type} opened={opened} nb={nb} focus={focus} /> );
ZLog.debug("notebook n", { n: n });
				if (n.kind === "viz") {
					lines.push( <RockNotebookViz key={n.uri + "viz"} node={n} service={service} type={type} opened={opened} nb={nb} focus={focus} /> );
				} else if (n.kind === "datasource") {
					lines.push( <RockNotebookDatasourceViewer key={n.uri + "datasource" + opened[n.uri]} node={n} service={service} type={type} opened={opened} nb={nb} focus={focus} /> );
				} else if (n.kind === "stats") {
					lines.push( <RockStatsViewer key={n.uri + "stats" + opened[n.uri]} node={n} service={service} type={type} opened={opened} nb={nb} focus={focus} /> );
				}
				let desc = n.description || type.description;
				if (desc) {
					lines.push( <RockNotebookDescription key={n.uri + "desc"} node={n} desc={desc} opened={opened} nb={nb} /> );
				}
				let readme = n.readme || type.readme
				if (readme) {
					lines.push( <RockNotebookReadme key={n.uri + "readme"} node={n} readme={readme} opened={opened} nb={nb} /> );
				}
				return lines;
			});
			contents = <div className="RockNotebookPipelineContents">
				{wtf ? <div className="RockNotebookWTF">{wtf}</div> : '' }
				{contents}
			</div>
		} else if (wtf) {
			contents = <div className="RockNotebookPipelineContents">
				<div className="RockNotebookWTF">{wtf}</div>
			</div>
		}
		return ( 
			<div className="RockNotebookPipeline">
				{pipe}
				{contents}
			</div>
		)
	}
	componentDidUpdate() {
		let { focused } = this.state;
		if (focused) {
			setTimeout( function() { 
				ZUtil.scrollToTop("nb_" + focused.uri, "rocknotebook_scroller", true);
			}, 10);
		}
	}
/*
		let { focused } = this.state;
console.log("focused?=" + focused);
		if (focused != null) { // && (this.moved_to_focused_component || 0) < 3) {
console.log("focused scroll to top=" + focused);
			ZUtil.scrollToTop("nb_" + focused.uri, "rocknotebook_scroller");
			this.moved_to_focused_component = (this.moved_to_focused_component || 0) + 1;;
		}
*/
}
class RockNotebookApp  extends React.Component {
	constructor(props) {
		super(props);
		let { focus, nodes } = props;
		this.state = { focused: focus && nodes.find( n => n.uri === focus) };
	}
	componentDidMount() {
		this.componentDidUpdate();
	}
	toggleWTF = (e) => {
		e.stopPropagation();
		e.preventDefault();
		this.setState({ wtf: this.state.wtf ? null : <div><strong>Service Application</strong>{AMC.buildHTMLFromMarkup(AMC.getSetting("wtf").dictionary["app"] || "What's This For? TBD")}</div> });
	}
	render() {
		let { nodes, opened, nb, focus } = this.props;
		let { wtf, focused } = this.state;

//ZLog.debug("RockNotebookApp - app nodes=", { nodes: nodes});
		let open = opened["app"];
		let wtf_button = <span className={"WTFButton" + (wtf ? " WTFButtonSelected" : "")} title="What's this For?" onClick={e => this.toggleWTF(e)}>WTF</span>

		let header = <div className="RockNotebookPipelineHeader" onClick={e => nb.toggleOpen("app")}>
				<FontAwesomeIcon icon={open ? faFolderOpen : faFolder} />
				<div className="RockNotebookPipelineBar" style={ROCK_NOTEBOOK_HEADER_STYLES["app"]}>
					{ "Service application" }
					{ wtf_button }
				</div>
		</div>
		let contents = [];
		if (open || focused) {
			contents = nodes.map( n => {
				let type = ZProps.get(n.type);
				let lines = [];
				if (!type) {
					ZLog.warn("Node type not found: " + n.type);
					return lines;
				}
				lines.push( <RockNotebookFunction key={n.uri + "f"} node={n} type={type} opened={opened} nb={nb} focus={focus} /> );
				let desc = n.description || type.description;
				if (desc) {
					lines.push( <RockNotebookDescription key={n.uri + "desc"} node={n} desc={desc} opened={opened} nb={nb} /> );
				}
				let readme = n.readme || type.readme
				if (readme) {
					lines.push( <RockNotebookReadme key={n.uri + "readme"} node={n} readme={readme} opened={opened} nb={nb} /> );
				}
				return lines;
			});
			contents = <div className="RockNotebookPipelineContents">
					{wtf ? <div className="RockNotebookWTF">{wtf}</div> : '' }
					{contents}
				   </div>
		} else if (wtf) {
			contents = <div className="RockNotebookPipelineContents">
				<div className="RockNotebookWTF">{wtf}</div>
			</div>
		}
		return ( 
			<div className="RockNotebookPipeline" id="nb_app">
				{header}
				{contents}
			</div>
		)
	}
	componentDidUpdate() {
		let { focused } = this.state;
		if (focused) {
			setTimeout( function() { 
				ZUtil.scrollToTop("nb_" + focused.uri, "rocknotebook_scroller", true);
			}, 10);
		}
	}
}
class RockNotebookFunction  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { node, type, opened, nb, focus } = this.props;
		let whitelist_props = (ZProps.get(type + ".spec") || { fields: []}).fields.map(f => f.field);
		let open = opened[node.uri];
		let f = <div className={"RockNotebookFunction ClearFix" + (focus === node.uri ? " RockNotebookHighlightedComponent" : "")}>
			<FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} onClick={e => nb.toggleOpen(node.uri)} />
			<div className="RockNotebookFunctionName" onClick={e => nb.onFocus(node.uri)}>
				{type.uri}( {Object.keys(node).filter(name => whitelist_props.indexOf(name) !== -1).map(name => { return name + "=" + node[name] }).join(", ")} )
			</div>
		</div>
		let body = [];
		if (open) {
			// add spec default parms
			body = <div className="RockNotebookFunctionBody">
				<RockInspectorSourceCode key={node.uri} item={node} />
			</div>
		}
		return (
			<div className="RockNotebookFunctionContainer" id={"nb_" + node.uri}>
				{f}
				{body}
			</div>
		)
	}
}
class RockNotebookViz  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	componentDidMount() {
		let { service, node } = this.props;
		this.service_state_subscription = ZAPI.subscribe(service.uri + "/feed", (topic, payload) => {
			if (payload.name === "image" && payload.uri === node.uri) {
				this.setState({ image: payload.image });
			}
		});
	}
	componentWillUnmount() {
		if (this.service_state_subscription) {
			ZAPI.unsubscribe(this.service_state_subscription);
		}
	}
	onError = () => {
		this.setState({ error: true });
	}
	render() {
		let { service, node, opened } = this.props;
		let { image, error } = this.state;
		if (!opened[node.uri]) {
			return null;
		}
		return (
			<div className={ error ? "RockNotebookVizEmpty" : "RockNotebookViz" }>
				<img alt="visualization" src={image || error ? "/images/clear.gif" : ZUtil.getDataServer() + "/" + service.uri + "/" + node.uri} onError={this.onError} />
			</div>
		)
	}
}

class RockNotebookDatasourceViewer extends React.Component {
        constructor(props) {
                super(props);
                this.state = { };
        }
        componentDidMount() {
		let { opened, node } = this.props;
		if (opened[node.uri]) {
                	if (node.kind !== "datasource") {
                        	return this.setState({ error: "Can only peek at a datasource" });
                	}
			let url = node.data || node.url || Object.keys(node).filter( key => key.startsWith("http") || key.startsWith("s3:") )[0];
			if (!url) {
				ZLog.debug("MVP not applicable for " + node.type);
                        	return this.setState({ error: "N/A" });
			}
                	ZNetwork.get("mvp", "preview", url, (err, data) => {
                        	this.setState({ error: err, data: data });
                	})
		}
        }
        render() {
		let { opened, node } = this.props;
                let { data, error } = this.state;
		if (!opened[node.uri]) {
			return null;
		}

                if (error === "N/A") {
                        return ""; // APIDAtaSource has no preview <ZooErrorFoundPage />;
                }
                if (error) {
                        return <ZooErrorFoundPage />;
                }
                if (!data) {
                        return <PleaseStandBy />;
                }
                if (data.length === 0) {
                        return <ZooNothingFoundPage />;
                }

//console.log("dddddddddddata=" + JSON.stringify(data));
                let payload = data.replace(/ /g, "&nbsp;").replace(/\r/g,"").split("\n").map( l => "<div>" + l + "</div>" ).join("");
                return	(
			<div className="RockNotebookDatasourceViewer">
                		<div className="RockNotebookDatasourceViewerData" dangerouslySetInnerHTML={{__html: payload}}></div>
			</div>
		);
        }
}

/*
class RockServiceStatsViewer extends React.Component {
        constructor(props) {
                super(props);
                this.state = { };
        }
        render() {
		let { opened, node, service } = this.props;
		if (!opened[node.uri]) {
			return null;
		}

		let atts = ZProps.get(node.type).atts;
		let stats = service.stats;
		let features = stats && stats.features;
ZLog.debug("RockStatsViewer", { atts: atts, features: features, stats: stats });

                if (!atts || !features || !stats) {
                        return ""; // Stats not executed yet
                }
		let rows = [];
		rows.push( features.map( f => <th key={f}>{f}</th> ) );
		rows[rows.length - 1].unshift( <td key="space"></td> );
		atts.forEach( att => {
			if (Array.isArray(stats[att])) {
				rows.push( stats[att].map( (stat, index) => <td key={att + "-" + index}>{parseFloat(stat).toFixed(2)}</td> ) );
				rows[rows.length - 1].unshift( <td key={att}>{att}</td> );
			}
		});
                let payload = <table><tbody>{ rows.map( (row, index) => <tr key={"row" + index}>{row}</tr> ) }</tbody></table>
                return	(
			<div className="RockNotebookStatsViewer">
                		<div className="RockNotebookStatsViewerData">{payload}</div>
			</div>
		);
        }
}
*/

class RockStatsViewer extends React.Component {
        constructor(props) {
                super(props);
                this.state = { };
        }
        render() {
		let { opened, node, service } = this.props;
		if (!opened[node.uri]) {
			return null;
		}

		let type = ZProps.get(node.type);
		let atts = type.atts;
		let stats = service.stats;
		let features = stats && stats.features;
//ZLog.debug("RockStatsViewer", { atts: atts, features: features, stats: stats });

                if (!atts || !features || !stats) {
                        return ""; // Stats not executed yet
                }
		let rows = [];
		if (node.format === 1 || Array.isArray(stats[atts[0]])) {
			rows.push( features.map( f => <th key={f}>{f}</th> ) );
			rows[rows.length - 1].unshift( <td key="space"></td> );
			atts.forEach( att => {
				rows.push( stats[att].map( (stat, index) => <td key={att + "-" + index}>{parseFloat(stat).toFixed(2)}</td> ) );
				rows[rows.length - 1].unshift( <td key={att}>{att}</td> );
			});
		} else {
//"describe":"{\"crim\":{\"count\":333.0,\"mean\":3.3603414715,\"std\":7.3522718368,\"min\":0.00632,\"25%\":0.07896,\"50%\":0.26169,\"75%\":3.67822,\"max\":73.5341},\"zn\":{\"count\":333.0,\"mean\":10.6891891892,\"std\":22.6747617966,\"min\":0.0,\"25%\":0.0,\"50%\":0.0,\"75%\":12.5,\"max\":100.0},\"indus\":
//console.log("dddddddddddata=" + JSON.stringify(stats[atts[0]]));
			let data = JSON.parse(stats[atts[0]]);
			let features = Object.keys(data);
			let columns = Object.keys(data[features[0]]).sort();
//console.log("features = " + features);
//console.log("columns = " + columns);
			rows = Array(columns.length + 1);
			//rows.forEach( r => r = [] );
			for (let i = 0; i < rows.length; ++i) {
				rows[i] = [];
			}
//console.log("rows.lenfgth=" + rows.length);
//console.log("rows[]=" + rows[0]);
			rows[0].push( features.map( feature => <th key={feature}>{feature}</th> ) );
			rows[0].unshift( <td key="space"></td> );
			columns.forEach( (c, index) => {
//console.log("columns.length = " + columns.length);
//console.log("index = " + index);
				rows[index + 1].push(<th key={c}>{c}</th>);
			});
			Object.keys(data).forEach( feature => {
				columns.forEach( (c, index) => {
					rows[index + 1].push(<td>{data[feature][c]}</td>);
				});
			});
		}
                let payload = <table><tbody>{ rows.map( (row, index) => <tr key={"row" + index}>{row}</tr> ) }</tbody></table>
                return	(
			<div className="RockNotebookStatsViewer">
                		<div className="RockNotebookStatsViewerData">{payload}</div>
			</div>
		);
        }
}

class RockNotebookDescription  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { desc, node, opened } = this.props;
		if (!opened[node.uri]) {
			return null;
		}
		return (
			<div className="RockNotebookDescription">
				{desc}
			</div>
		)
	}
}

class RockNotebookReadme  extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { node, readme, opened } = this.props;
		return (
			<div className="RockNotebookReadme">
				{ opened[node.uri] ? readme : <div>more</div> }
			</div>
		)
	}
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    this.setState({ error });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children; 
  }
}
				
class RockRawProperties  extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { item, togglePanel } = this.props;
		let type;
		let impuri;
		if (item.kind === "service") {
			// Cannot edit raw properties of service
			this.setState({ sourceless: true });
			return togglePanel("notebook", true);
		}
/*
		if (item.kind === "ui") {
			ZLog.error("Raw UI not supported. Just edit source code");
			return this.setState({ sourceless: true });
		}
*/
ZLog.debug("RockRawProperties item:", { item: item});
		let user = ZProps.get("user");
		if (item.kind === "freakout" || item.kind === "helpmechoose" || item.kind === "wtf" || item.kind === "rockpile" || item.kind === "themes") {
			this.editable = false; // until we add save this kind of saveraw to server... user.group === item.group;
			let showable = {};
			["name", "kind", "language", "description", "permissions", "inputs", "outputs", "dependencies", "readme", "license", "dictionary", "list"].forEach( prop => {
				if (item[prop]) {
					showable[prop] = item[prop];
				}
			});
			let code = JSON.stringify(showable, null, 2);
			this.setState({ sourcecode: code, text: code });
			this.componentDidUpdate();
			return;
		}
		if (item.kind === "service") {
			return togglePanel("source", true);
		}

		if (!item.type) {
			this.is_type = true;
			type = item;
		} else {
			type = ZProps.get(item.type);
			if (!type) {
				return AMC.get(item.type, (err, type) => {
					if (err) {
						ZLog.error("Unable to fetch type: " + item.type);
						this.setState({ sourceless: true });
					} else {
						this.componentDidMount();
					}
				});
			}
		}
		AMC.getSpec(item, (err, spec) => {
			impuri = type.uri + ".imp";
			this.language = "py"; // this.uri.lastIndexOf(".") !== -1 ? this.uri.substring(this.uri.lastIndexOf(".") + 1) : "js";
			this.editable = user.group === type.group;
			var text = ZProps.get(impuri);
			if (text) {
				this.setState({ sourcecode: this.buildRaw(item, type, spec, text) });
				this.componentDidUpdate();
				return;
			}
			ZNetwork.get("sourcecode", impuri, (err, text) => {
				if (err) {
					ZLog.error("Unable to fetch source code: " + impuri);
					this.setState({ sourceless: true });
					togglePanel("notebook", true);
				} else {
					ZProps.set(impuri, text);
					this.setState({ sourcecode: this.buildRaw(item, type, spec, text) });
					this.componentDidUpdate();
				}
			});
		});
	}
/*
# @component {
#	"kind" : "viz",
#	"language" : "py",
#	"description" : "Plot of loss vs. val_loss",
#	"permissions": "public",
#	"properties": [
#		{ "name": "parm1" , "field": "parm1", "kind": "string", "minlen": 1, "maxlen": 62, "required": true, "default": "loss" },
#		{ "name": "parm2" , "field": "parm2", "kind": "string", "minlen": 1, "maxlen": 62, "required": true, "default": "val_loss" }
#	],
#	"inputs": ["X:pandas", "y:pandas", "history:dict" ],
#	"outputs": ["X:pandas", "y:pandas", "history:dict" ],
#	"dependencies": ["matplotlib"],
#	"readme" : "",
#	"license" : ""
# }
*/
	buildRaw(component, type, spec, sourcecode) {
		let lines = ["@component {"];
		["name", "kind", "language", "description", "permissions", "inputs", "outputs", "dependencies", "readme", "license"].forEach( prop => {
			let value = component[prop] || type[prop];
			if (value != null) {
				lines.push(`    "${prop}": ${JSON.stringify(value)},`);
			}
		});
		lines.push('    "properties": [');
		lines = lines.concat(((spec && spec.fields) || []).map( s => "        " + JSON.stringify(s) ));
		lines.push('    ]');
		lines.push("}");
		lines = lines.map( line => "# " + line);
		lines = lines.concat(sourcecode);
		return lines.join("\n");
	}
		
	componentWillUnmount() {
		if (this.editor) {
			this.editor.destroy();
			this.editor.container.remove();
			this.editor = null;
		}
	}
	/*
		save to server and then reload service bundle
	*/
	onChange(text) {
		let { item } = this.props;
		let parsed = this.splitComponentFileContent(item.uri, text);
		if (parsed.error) {
			return this.setState({ error: parsed.error });
		}
		this.setState({ changed: true, text: text });
		this.save(text);
	}
	save = (text) => {
		let { item, transman, service } = this.props;
		ZUtil.throttle("RockPropertiesForm" + item.uri, () => {
			this.setState({ changed: false });
			AMC.updateRaw(item.uri, text, (err, payload) => {
/*
			ZNetwork.post("thing", "raw", { uri: item.uri, raw: text }, (err, payload) => {
				if (!err) {
					ZProps.set(payload.uri, payload.component);
					ZProps.set(payload.uri + ".spec", payload.spec);
					ZProps.set(payload.uri + ".imp", payload.imp);
*/
				if (!err) {
					if (!this.is_type && item.uri !== payload.uri) {
						// modify instance uri inside of service if change kind or imp function name...
						if (service && AMC.isEditable(service)) {
							let id = transman.startTransaction("user edited " + item.name);
							transman.modifyPart(item.uri, { uri: payload.uri });
							transman.endTransaction(id);
						}
					}
				}
			});
		}, 1000);
	}
	splitComponentFileContent(uri, content) {
		let lines = content.split("\n");
		let sections = {};
		let component = {};
		let source = {};
		let spec = {};
		let section = null;
		lines.forEach( line => {
			if (line[0] === "#") {
				if (section === "component") {
					line = line.substring(1).trim();
				} else if (line.indexOf("@component") !== -1) {
					section = "component"
					line = line.substring(1).replace("@component", "").trim();
				}
			} else if (line.length > 0) {
				section = "source";
			}
			if (section) {
				sections[section] = sections[section] || [];
				sections[section].push(line);
			}
		});
		if (sections.component) {
			try {
				component = JSON.parse(sections.component.join("").replace(/\r/g,""));
			} catch(e) {
				ZLog.error("Unable to parse component file definition for " + uri + "(" + e + ")");
				return { error: "Unable to parse component file definition for " + uri + "(" + e + ")" };
			}
		}
		component.uri = uri;
		component.name = component.name || uri.split("/")[2];
		source.uri = uri + ".imp";
		source.kind = "source"
		source.code = sections.source.join("\n").replace(/\r/g,"");
		spec.uri = uri + ".spec";
		spec.kind = "spec"
		spec.fields = component.properties || []
		delete component.properties;
		return { source, component, spec }
	}
	render() {
		let { item } = this.props;
		let { sourcecode, error, sourceless, urichanged, text } = this.state;
		if (sourceless) {
			return <div className="CENTERED">No raw code available</div>
		}
		if (!sourcecode) {
			return <PleaseStandBy />;
		}
		return (
			<div className="RockRawProperties">
				{ urichanged ? <div className="RockRawPropertiesHeader"><div className="RockButton" onClick={e => this.save(text)}>Save new component</div></div> : '' }
				<div className={"WZooSourceCodeEditorContainer" + (error ? " WZooSourceCodeEditorContainerError" : "") + (this.editable ? "" : " WZooSourceCodeEditorContainerReadOnly") }>
					<div className="WZooSourceCodeEditor" data-language={this.language} id={sourcecode ? "zoo-source-code" + item.uri : ""}>{sourcecode}</div>
				</div>
			</div>
		);
	}
	componentDidUpdate() {
		let { item } = this.props;
		if (document.getElementById("zoo-source-code" + item.uri) && !this.editor) {
			var container = document.getElementById("zoo-source-code" + item.uri);
			var language = container.getAttribute("data-language");
			this.editor = window.ace.edit("zoo-source-code" + item.uri);
			this.editor.setOption("wrap", true)
			if (!this.editable) {
				this.editor.setReadOnly(true);
			} else {
				this.editor.session.on('change', () => {
					this.onChange(this.editor.getSession().getValue());
				});
			}
			switch (language) {
				case "js" :
					this.editor.session.setMode("ace/mode/javascript");
					break;
				case "py" :
					this.editor.session.setMode("ace/mode/python");
					break;
				case "json" :
					this.editor.session.setMode("ace/mode/json");
					break;
				case "html" :
					this.editor.session.setMode("ace/mode/html");
					break;
				default: 
					ZLog.error("Unknown source code language: " + language);
					break;
			}
		}
	}
}
export class RockInspectorSourceCode extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	isSpecial(item) {
		return ["theme", "wtf", "ninja", "architecture", "service", "helpmechoose", "freakout", "rockpile", "themes"].indexOf(item.kind) !== -1;
	}
	componentDidMount() {
		let { item } = this.props;
		let user = ZProps.get("user");
		if (this.isSpecial(item)) {
			this.language = "json";
			this.editable = item.group === user.group; // user.plan !== "guest";
			this.impuri = item.uri;
			this._extractEditables(item, (err, text) => {
				if (!err) {
					this.setState({ sourcecode: JSON.stringify(text, null, 2) });
					this.componentDidUpdate();
				}
			});
			return;
		}
		var type = item.type ? ZProps.get(item.type) : item;
		this.impuri = (item.type || item.uri) + ".imp";
		this.language = "py"; // this.impuri.lastIndexOf(".") !== -1 ? this.impuri.substring(this.impuri.lastIndexOf(".") + 1) : "js";
		this.editable = user.group === type.group;
		var text = ZProps.get(this.impuri);
		if (text) {
			this.setState({ sourcecode: typeof text === "string" ? text : text.code });
			this.componentDidUpdate();
			return;
		}
		ZNetwork.get("sourcecode", this.impuri, (err, text) => {
			if (err) {
				ZLog.error("Unable to fetch source code: " + this.impuri);
				this.setState({ sourceless: true });
			} else {
				ZProps.set(this.impuri, text);
				this.setState({ sourcecode: text });
				this.componentDidUpdate();
			}
		});
	}
	_extractEditables(item, callback) {
		let uri = item.uri;
		let obj = ZProps.get(uri);
		let text = null;
		if (obj) {
			if (item.kind === "architecture") {
				text = { template: obj.template };
			} else if (item.kind === "service") {
//				text = { nodes: obj.nodes };
				text = { service: this.stripService(obj) };
			} else if (item.kind === "wtf" || item.kind === "helpmechoose") {
				text = { dictionary: obj.dictionary };
			} else if (item.kind === "freakout" || item.kind === "rockpile" || item.kind === "themes") {
				text = { list: obj.list };
			} 
			callback(null, text || obj);
		} else {
			ZNetwork.get("thing", uri, (err, obj) => {
				if (err || !obj) {
					ZLog.error("Unable to fetch source for : " + item.name);
					callback("Unable to fetch source for : " + item.name);
				} else {
					ZProps.set(uri, obj);
					this._extractEditables(item, callback);
				}
			});
		}
	}
	componentWillUnmount() {
		if (this.editor) {
			this.editor.destroy();
			this.editor.container.remove();
			this.editor = null;
		}
	}
	stripService(service) {
		// remove kind, uri, stats, deleted, owner?
		let new_service = ZUtil.clone(service);
		let blacklist = { kind: 1, deleted: 1, owner: 1, group: 1, visits: 1, useds: 1, likes: 1, dislikes: 1, stars: 1, comments: 1, runs: 1, score: 1, updates: 1, clones: 1, freakouts: 1, wtfs: 1, updated_at: 1, lockholder: 1 };
		Object.keys(new_service).forEach( k => { if (blacklist[k]) { delete new_service[k] } } );
		let nodes = AMC.getFlattenedService(new_service);
		nodes.forEach(n => Object.keys(n).forEach( k => { if (blacklist[k]) { delete n[k] } } ) );
		return new_service;
	}
	unstripService(new_service, old_service) {
		// restore kind, deleted 0
		let uri_to_old_node = {};
		let old_service_obj = Object.assign({}, old_service);
		delete old_service_obj.nodes;
		Object.assign(new_service, Object.assign(old_service_obj, new_service));
		let new_nodes = AMC.getFlattenedService(new_service);
		let old_nodes = AMC.getFlattenedService(old_service);
		old_nodes.forEach( n => uri_to_old_node[n.uri] = n );
		new_nodes.forEach( n => Object.assign(n, Object.assign(Object.assign({}, uri_to_old_node[n.uri]), n)) );
		return new_service;
	}
	onChange(text) {
		ZUtil.throttle(this.impuri, () => {
		let { item } = this.props;
		if (this.isSpecial(item)) {
			try {
				if (item.kind === "architecture") {
					item.template = JSON.parse(text).template;
				} else if (item.kind === "service") {
					item = this.unstripService(JSON.parse(text).service, item);
				} else if (item.kind === "wtf" || item.kind === "helpmechoose") {
					item.dictionary = JSON.parse(text).dictionary;
				} else if (item.kind === "freakout" || item.kind === "rockpile" || item.kind === "themes") {
					item.list = JSON.parse(text).list;
				} else {
					item = JSON.parse(text);
				}
			} catch (e) {
				this.setState({ error: "Invalid JSON: " + e });
				return;
			}
		}
		this.setState({ error: null });
		text = JSON.stringify(item);
		//ZUtil.throttle(this.impuri, () => {
			ZNetwork.post("sourcecode", this.impuri, null, { data: text }, (err) => {
				if (!err) {
					ZProps.set(this.impuri, text);
				} else {
					this.setState({ error: err });
				}
			});
		}, 1000);
	}
	render() {
		let { item } = this.props;
		let { sourcecode, error, sourceless } = this.state;
//console.log("this.state.sourcecode=" + sourcecode);
		if (sourceless) {
			return <div className="CENTERED">No source code available</div>
		}
		if (!sourcecode) {
			return <PleaseStandBy />;
		}
		return (
			<div className={"WZooSourceCodeEditorContainer" + (error ? " WZooSourceCodeEditorContainerError" : "") + (this.editable ? "" : " WZooSourceCodeEditorContainerReadOnly") }>
				<div className="WZooSourceCodeEditor" data-language={this.language} id={this.state.sourcecode ? "zoo-source-code" + item.uri : ""}>{this.state.sourcecode}</div>
			</div>
		);
	}
	componentDidUpdate() {
		let { item } = this.props;
		if (document.getElementById("zoo-source-code" + item.uri) && !this.editor) {
			var container = document.getElementById("zoo-source-code" + item.uri);
			var language = container.getAttribute("data-language");
			this.editor = window.ace.edit("zoo-source-code" + item.uri);
			this.editor.setOption("wrap", true)
			if (!this.editable) {
				this.editor.setReadOnly(true);
			} else {
				var self = this;
				this.editor.session.on('change', function() {
					self.onChange(self.editor.getSession().getValue());
				});
			}
			switch (language) {
				case "js" :
					this.editor.session.setMode("ace/mode/javascript");
					break;
				case "py" :
					this.editor.session.setMode("ace/mode/python");
					break;
				case "json" :
					this.editor.session.setMode("ace/mode/json");
					break;
				case "html" :
					this.editor.session.setMode("ace/mode/html");
					break;
				default: 
					ZLog.error("Unknown source code language: " + language);
					break;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/RockPanel.js